import { Box, Stack, StackProps, Switch, SwitchProps, styled } from '@mui/material';
import { ReactNode } from 'react';

const CardContainer = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    height: 56,
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: `inset 0px -1px 0px ${theme.palette.grey[200]}`,
    gap: theme.spacing(1.5),
}));

const IconContainer = styled(Box)(() => ({
    width: 32,
    height: 32,

    '& svg': {
        fontSize: 32,
    },
}));

export interface OptionCardProps extends Omit<StackProps, 'onChange' | 'onBlur'> {
    value: boolean;
    id?: string;
    icon?: ReactNode;
    disabled?: boolean;
    name?: SwitchProps['name'];
    onChange?: SwitchProps['onChange'];
    onBlur?: SwitchProps['onBlur'];
}

export const OptionCard = (props: OptionCardProps) => {
    const { name, icon, children, disabled, id, value, onChange, onBlur, ...stackProps } = props;

    return (
        <CardContainer {...stackProps} sx={disabled ? { opacity: 0.4 } : {}}>
            {icon && <IconContainer>{icon}</IconContainer>}
            <Box flex={1}>{children}</Box>
            <Box>
                <Switch
                    id={id}
                    name={name}
                    color="primary"
                    checked={value}
                    onChange={onChange}
                    disabled={disabled}
                    onBlur={onBlur}
                    sx={{ opacity: disabled ? 0.4 : 1 }}
                />
            </Box>
        </CardContainer>
    );
};
